import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class ProductInstanceDownloadResource extends AuthenticatedResource {
  static urlRoot = 'organizations/:organization_id/product_instances/download' as const;

  pk() {
    return 'download';
  }
}
